import { render, staticRenderFns } from "./eu-prod-info.vue?vue&type=template&id=9b6dd8c6&"
import script from "./eu-prod-info.vue?vue&type=script&lang=js&"
export * from "./eu-prod-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports